/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { v4 as uuidv4 } from "uuid";
import config from "../config/evidenceKanbanList.config.json";

export interface IEvidenceKanbaListMethods extends IPluginMethodMap {
  getEvidenceKanbanList(args: any): Promise<any>;
  getEvidenceKanbanProps(args: any): Promise<any>;
  updateEvidenceKanbanList(args: any): Promise<any>;
}

export class EvidenceKanbanListService implements IAgentPlugin {
  readonly methods: IEvidenceKanbaListMethods;
  private list: any[] = config.kanbanList;
  constructor() {
    this.methods = {
      getEvidenceKanbanList: this.getList.bind(this),
      getEvidenceKanbanProps: this.getProps.bind(this),
      updateEvidenceKanbanList: this.updateList.bind(this),
    };
    this.list[0].id = uuidv4();
  }

  async getProps(args: any) {
    return {
      ...(config || {}),
      evidenceKanbanList: this.list,
    };
  }

  async updateList(args: any) {
    if (args) {
      this.list = args;
    }
  }

  async getList(args: any) {
    return {
      evidenceKanbanList: this.list,
    };
  }
}
